export default __webpack_public_path__ + "static/media/avatar-anisha.484e15bc.png";